module.exports = __webpack_public_path__ + "img/10.5ac29d51.png";